import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: "it",
    debug: true,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    ns: [
      "common",
      "imagesSentence",
      "profilePage",
      "signin",
      "philosophy",
      "cookie",
      "privacy",
      "forumRules",
      "error",
    ],
    // No explicit "lng" here: setting it overrides LanguageDetector entirely,
    // forcing every first-time visitor to Italian regardless of their browser
    // language. fallbackLng above already covers the "detection failed" case.
    supportedLngs: ["it", "fr"],
  });

export default i18n;
